<div class="site-footer__widget footer-links d-md-block d-none">
    <h5 class="text-uppercase link-header mb-6" >{{header| translate}}</h5>
    <ul class="footer-links__list mb-4">
        <li *ngFor="let link of links" class="footer-links__item">
            <a [routerLink]="['/page',link?.seo?.slug]" class="footer-links__link">{{
                translateHelper.localize(link?.name) }}</a>
        </li>
    </ul>
</div>

<div class="site-footer__widget footer-links d-md-none d-block">
    <h5 class="footer-links__title text-uppercase py-2 m-0" (click)="showList = !showList">{{header}}</h5>
    <ul class="footer-links__list p-2 collapse" [ngClass]="{'show': showList}">
        <li *ngFor="let link of links" class="footer-links__item">
            <a [routerLink]="['/page',link?.seo?.slug]" class="footer-links__link">{{
                translateHelper.localize(link?.name) }}</a>
        </li>
    </ul>
</div>
